export enum SELLERS_INFO_DOMAIN {
  ALL_SELLERS = 'allSellers',
}
